import { createRouter, createWebHistory } from 'vue-router'
import { state } from '@/config/msalConfig'

const router = createRouter({
  // linkExactActiveClass: 'border-l-4 border-white rounded-4 bg-slate-500 rounded',
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/home',
      component: () => import('../layouts/MainLayout.vue'),
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import('../views/HomeView.vue')
        },
        {
          path: 'applications',
          name: 'applications',
          component: () => import('../views/ApplicationsView.vue')
        },
        {
          path: 'applications/:applicationId',
          name: 'application-detail',
          component: () => import('../views/ApplicationDetailView.vue')
        },
        {
          path: 'agreement-types',
          name: 'agreement-types',
          component: () => import('../views/AgreementTypesView.vue')
        },
        {
          path: 'agreement-types/:agreementTypeId',
          name: 'agreement-type-detail',
          component: () => import('../views/AgreementTypeDetailView.vue')
        },
        {
          path: 'dynamic-texts/keys',
          name: 'dynamic-text-keys',
          component: () => import('../views/DynamicKeysView.vue')
        },
        {
          path: 'dynamic-texts/languages',
          name: 'dynamic-text-languages',
          component: () => import('../views/LanguagesView.vue')
        },
        {
          path: 'dynamic-texts/defaults',
          name: 'dynamic-text-defaults',
          component: () => import('../views/DynamicKeyDefaultsView.vue')
        },
        {
          path: 'dynamic-texts/dealers',
          name: 'dynamic-text-dealers',
          component: () => import('../views/DynamicKeyDealersView.vue')
        },
        {
          path: 'profile',
          name: 'Profile',
          component: () => import('../views/ProfileView.vue')
        },
      ]
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('../layouts/ErrorLayout.vue'),
      meta: { anonymous: true }
    },
    {
      path: '/:pathMatch(.*)',
      component: () => import('../views/NotFoundView.vue')
    }
  ]
})

function checkIsAdmin() {
  if (!state.isAdmin) {
    return {
      path: '/error',
      query: {
        status: 403,
        title: 'Unauthorized',
        description: 'You do not have access to the requested page'
      }
    }
  }
}

export default router
